<template>
  <page-news-layout>
    <div>
      <h2 class="pb-3">{{ $t("about_us_news_right_flex_four") }}</h2>
    </div>
    <div v-for="(c, index) in content" :key="c">
      <div v-if="index == 3">
        <p>
          {{ $t(c.p) }}
        </p>
      </div>
      <div v-else>
        <p>{{ $t(c.p) }}</p>
        <h4>{{ $t(c.h) }}</h4>
      </div>
    </div>
    <div class="mt-5 mb-5">
      <base-link-button link="/about"></base-link-button>
    </div>
  </page-news-layout>
</template>
<script>
import BaseLinkButton from "@/components/BaseLinkButton.vue"
import PageNewsLayout from "@/components/PageNewsLayout.vue"
export default {
  components: { BaseLinkButton, PageNewsLayout },
  name: "DigitalTransformation",
  data() {
    return {
      chips: [{ chip: "#erp" }, { chip: "#digitalna-transformacija" }],
      content: [
        { p: "digital_trans_p1", h: "digital_trans_h1" },
        { p: "digital_trans_p2", h: "digital_trans_h2" },
        { p: "digital_trans_p3", h: "digital_trans_h3" },
        { p: "digital_trans_p4" }
      ]
    }
  }
}
</script>
<style lang="scss" scoped></style>
